import { EmptyStateVariantType } from '../../../../../../components/internal/emptyState/types/emptyStateVariantType';
import { commonStyles } from '../commonStyles';
export const getEmptyStateRegularStyles = (FOUNDATIONS, FONT) => ({
    [EmptyStateVariantType.REGULAR]: { ...commonStyles(FOUNDATIONS, {}) },
});
//# sourceMappingURL=regular.js.map